import type { Product } from '@skop-app/lib-domain/types'

import type { Context } from '@/types'
import { adaptProductStatuses } from '@/services/product/productStatus.adapter'

/** Retain the occurrence snapshot needed to remove legacy catalogue fallbacks. */
export const adaptCatalogProductStatuses = (
  products: Product[],
  context: Partial<Context>,
) => {
  const propertiesByID = new Map(
    products
      .filter((product) =>
        Object.prototype.hasOwnProperty.call(product, 'properties'),
      )
      .map((product) => [product.id, product.properties]),
  )

  return adaptProductStatuses(products, context).map((product) =>
    propertiesByID.has(product.id)
      ? { ...product, properties: propertiesByID.get(product.id) }
      : product,
  )
}
